import { render, staticRenderFns } from "./relatedLink.vue?vue&type=template&id=19d7206a&"
import script from "./relatedLink.vue?vue&type=script&lang=js&"
export * from "./relatedLink.vue?vue&type=script&lang=js&"
import style0 from "./relatedLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports